<template>
  <div class="wrapper">
    <loading
      :show="isLoading"
      :text="'Please wait...'"
    />
    <div class="content">
      <div class="container">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import Loading from '../components/shared/Loading.vue';

export default {
  name: 'SocialAuthLayout',
  components: { Loading },

  computed: {
    isLoading() {
      return this.$store.getters.isLoading;
    },

  },
};
</script>

<style scoped>
  .wrapper {
    width: 100%;
    height: 100vh;
  }
</style>
